import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import Color from '@tiptap/extension-color';
import Placeholder from '@tiptap/extension-placeholder';
import blogService from '../../services/blogService';
import MenuBar from '../../components/TipTapEditor';

const CreatePost = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [excerpt, setExcerpt] = useState('');
  const [category, setCategory] = useState('');
  const [published, setPublished] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      Link.configure({
        openOnClick: false,
      }),
      Image,
      Color,
      Placeholder.configure({
        placeholder: 'Write your post content here...',
      }),
    ],
    content: '',
    onUpdate: ({ editor }) => {
      // Handle content updates if needed
    }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editor || !title.trim()) {
      setError('Please fill in all required fields');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const postData = {
        title: title.trim(),
        content: editor.getHTML(),
        excerpt: excerpt.trim(),
        category: category.trim() || null,
        published,
        author: 'Admin', // This should come from the authenticated user
      };

      console.log('Submitting post data:', postData);
      const response = await blogService.createPost(postData);
      console.log('Post creation response:', response);
      navigate('/admin/posts');
    } catch (err) {
      console.error('Post creation error:', err);
      setError(err.response?.data?.error || 'Failed to create post. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-create-post">
      <h1>Create New Post</h1>
      
      {error && <div className="alert alert-danger">{error}</div>}
      
      <form onSubmit={handleSubmit} className="post-form card mt-2">
        <div className="form-group mb-3">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Post Title"
            required
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="excerpt">Excerpt</label>
          <textarea
            id="excerpt"
            className="form-control"
            value={excerpt}
            onChange={(e) => setExcerpt(e.target.value)}
            placeholder="Brief description of the post"
            rows="3"
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="category">Category</label>
          <input
            type="text"
            id="category"
            className="form-control"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="Post Category"
          />
        </div>

        <div className="form-group mb-3">
          <div className="form-check">
            <input
              type="checkbox"
              id="published"
              className="form-check-input"
              checked={published}
              onChange={(e) => setPublished(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="published">
              Publish immediately
            </label>
          </div>
        </div>

        <div className="form-group mb-3">
          <label>Content</label>
          <div className="editor-toolbar">
            <MenuBar editor={editor} />
          </div>
          <div className="editor-content">
            <EditorContent editor={editor} />
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={() => navigate('/admin/posts')}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Post'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreatePost; 